import Chip from '@components/v2/ui/Chip/Chip';
import { Box } from '@mui/material';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../modules/translation/TranslationContext';
import { ScreenHeaderTagConfig } from '../screenHeader.types';

interface ScreenHeaderTagProps extends ScreenHeaderTagConfig {
  isCollapsed?: boolean;
}

export const ScreenHeaderTag = ({
  label,
  icon,
  testId,
  onClick,
  isCollapsed,
}: ScreenHeaderTagProps) => {
  const { translate } = useTranslation();
  const translatedLabel = translate(label as LangEnum);

  const iconSlot = icon ? (
    <Box component="span" sx={{ display: 'flex', alignItems: 'center', lineHeight: 0 }}>
      {icon}
    </Box>
  ) : undefined;

  const isIconOnly = Boolean(isCollapsed && iconSlot);

  return (
    <Chip
      size="small"
      testId={testId}
      title={isIconOnly ? translatedLabel : undefined}
      onClick={onClick}
      icon={isIconOnly ? undefined : iconSlot}
      label={
        isIconOnly ? (
          <Box
            component="span"
            role="img"
            aria-label={translatedLabel}
            sx={{ display: 'flex', alignItems: 'center', lineHeight: 0 }}
          >
            {icon}
          </Box>
        ) : (
          translatedLabel
        )
      }
      sx={{
        flexShrink: 0,
        ...(onClick ? {} : { '&:hover': { bgcolor: 'secondary.light' } }),
      }}
    />
  );
};
